import axios, { AxiosResponse } from 'axios';
import { put, takeLatest, select , all, takeEvery} from 'redux-saga/effects';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { serverError } from '@state/auth/actions';
import host from '@utils/host';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { UserManager } from 'oidc-client';

function* fetchUserFiles(action: actionsInterfaces.IFetchUserFilesAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}userFiles`    
    if(action.query)callUrl=`${host}userFiles${action.query}`

    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.userFiles.setUserFiles(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* getUserFiles(action: actionsInterfaces.IFetchUserFilesAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}userFiles`    
    if(action.query)callUrl=`${host}userFiles${action.query}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.userFiles.setUserFiles(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* addUserFiles(action: actionsInterfaces.IPostUserFilesAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}userFiles`, action.userFiles,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.userFiles.addSuccess({status:response.status, id:action.userFiles.id, name:action.userFiles.user.name}));
      if (action.callback) { action.callback(response.data[0]); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      yield put(actions.userFiles.addSuccess({status:response.status, id:action.userFiles.id, name:action.userFiles.user.name}));
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchSearchUserFiles(action: actionsInterfaces.IFetchUserFilesAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}userFiles`    
    if(action.query)callUrl=`${host}userFiles${action.query}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.userFiles.setSearch(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchCounter(action: actionsInterfaces.IFetchCounterAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}userFilescount`    
    if(action.filter)callUrl=`${host}userFilescount${action.filter}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.userFiles.setCounter(response.data[0]));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateUserFiles(action: actionsInterfaces.IUpdateUserFilesAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.put(`${host}userFiles/${action.userFiles.id}`,action.userFiles,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* deleteUserFiles(action: actionsInterfaces.IUpdateUserFilesAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.delete(`${host}userFiles/${action.userFiles.id}`,{data: action.userFiles,headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* bulkDeleteUserFiles(action: actionsInterfaces.IBulkDeleteFilesAction) {
  try {
    const token: string = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.delete(
      `${host}userFiles/bulk-delete`, {
        data: action.userFiles,
        headers: {Authorization: token}
      });

    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) {
        action.callback("Files deleted successfully", null);
      }
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }
  } catch (error) {
    console.error("Error deleting files:", error);
    if (action.callback) {
      action.callback(null, error);
    }
  }
}

export default function* budgetSagas() {
  yield all([
    takeLatest(actionsTypes.FETCH_USERFILES, fetchUserFiles),
    takeLatest(actionsTypes.GET_USERFILES_INFO, getUserFiles),
    takeEvery(actionsTypes.ADD_USERFILES, addUserFiles),
    takeLatest(actionsTypes.FETCH_SEARCH_USERFILES, fetchSearchUserFiles),
    takeLatest(actionsTypes.FETCH_COUNTER, fetchCounter),
    takeLatest(actionsTypes.UPDATE_USERFILES, updateUserFiles),
    takeLatest(actionsTypes.DELETE_USERFILES, deleteUserFiles),
    takeLatest(actionsTypes.BULK_DELETE_USERFILES, bulkDeleteUserFiles)
  ])
}

